export const WOUND_IMAGE_LIST = [
  { key: "measuredimage", value: "Measured Image" },
  { key: "binaryimage", value: "Binary Image" },
  { key: "rawimage", value: "Initial Image" },
  { key: "none", value: "None" },
];

export const CHARACTERISTIC = [
  { key: "history", value: "History" },
  { key: "cause", value: "Cause" },
  { key: "tissuetype", value: "Tissue Type" },
  { key: "touch&viewdetails", value: "Touch & View Details" },
  { key: "customform ", value: "Custom Form" },
  { key: "classification", value: "Classification" },
  { key: "setprogress", value: "Set Progress" },
];

export const MEASUREMENTS = [
  { key: "surfacearea", value: "Surface Area" },
  { key: "length", value: "Length" },
  { key: "width", value: "Width" },
  { key: "depth", value: "Depth" },
  { key: "undermining", value: "Undermining" },
  { key: "tunneling", value: "Tunneling" },
];

export const TREATEMENT = [
  { key: "dressingappearance", value: "Dressing Appearance" },
  { key: "debridement", value: "Debridement" },
  { key: "woundcleanser", value: "Wound Cleanser" },
  { key: "skinprotectant", value: "Skin Protectant" },
  { key: "primarydressing", value: "Primary Dressing" },
  { key: "secondarydressing", value: "Secondary Dressing" },
  { key: "compression", value: "Compression" },
  { key: "modalities", value: "Modalities" },
  { key: "additionalcare", value: "Additional Care" },
  { key: "dressingchangefrequency", value: "Dressing Change Frequency" },
];
